module.exports = __webpack_public_path__ + "static/media/0.4de6ffa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyebrowes/0.png
// module id = 487
// module chunks = 0